import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { CustomSpinnerComponent } from '@core/components/ui-custom-spinner/custom-spinner.component';
import type { ICustomSelectModel } from '@core/models/custom-select.interface';
import type { DetailsModel } from '@core/components/ui-clinng-status-alert/ui-clinng-status-alert.component';
import type { TicketDetails } from '@core/components/ui-clinng-ticket-info/ui-clinng-ticket-info.component';
import { UiClinngButtonComponent } from '@core/components/ui-clinng-button/ui-clinng-button.component';
import { UiClinngStaticHeaderComponent } from '@core/components/ui-clinng-static-header/ui-clinng-static-header.component';
import { CheckoutEstadoEnum, CheckoutSubestadoFinalizadoEnum } from '@core/models/states.enum';
import { FormPseComponent } from '../form-pse/form-pse.component';
import { ResponsiveService } from '@core/services/responsive.service';
import { MoviiService } from '@core/services/movii.service';
import type { MoviiCreateOperationRequest, MoviiSessionDetails } from '@core/services/movii.interface';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { finalize, timeout } from 'rxjs';
import { deferViewUpdate } from '@core/utils/defer-view-update';

@Component({
  selector: 'checkout-pse-form-container',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatSelectModule,
    MatButtonModule,
    MatInputModule,
    MatCheckboxModule,
    MatIconModule,
    MatSnackBarModule,
    CustomSpinnerComponent,
    UiClinngButtonComponent,
    UiClinngStaticHeaderComponent,
    FormPseComponent],
  templateUrl: './checkout-pse-form-container.component.html',
  styleUrl: './checkout-pse-form-container.component.scss',
})
export class CheckoutPseFormContainerComponent {
  @ViewChild(FormPseComponent) formPseComponent!: FormPseComponent;
  esResponsive$ = this.responsiveService.esResponsive$;

  estado: CheckoutEstadoEnum = CheckoutEstadoEnum.INGRESO_DATOS;
  estadoModel = CheckoutEstadoEnum;

  subEstado: CheckoutSubestadoFinalizadoEnum | null = null;
  subEstadoModel = CheckoutSubestadoFinalizadoEnum;
  detailsModel!: DetailsModel;
  aceptoTerminos: boolean = false;

  operationInfo!: MoviiSessionDetails;
  download: boolean = false;
  transactionId!: string;
  verification!: string;
  bankList: ICustomSelectModel[] = [];
  documentValues: any[] = [];
  loading: boolean = false;
  initLoading: boolean = true;

  constructor(
    private responsiveService: ResponsiveService,
    private moviiService: MoviiService,
    private route: ActivatedRoute,
    private router: Router,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.verification = this.route.snapshot.paramMap.get('verification') ?? '';
    this.getPaymentDetails();
    this.getDocuments('N');
  }

  getDocuments(documentType: 'N' | 'J' = 'N') {
    this.moviiService.findDocumentByCountry(documentType).subscribe(
      (data: any) => {
        this.documentValues = data;
      },
      (error) => {
        console.error('Error en la solicitud:', error);
      }
    )


  }
  getPaymentDetails() {
    if (!this.verification) {
      deferViewUpdate(this.cdr, () => {
        this.initLoading = false;
        this.router.navigate(['/error-status/movii']);
      });
      return;
    }

    this.moviiService.getPaymentDetails(this.verification)
      .pipe(
        timeout(30_000),
        finalize(() => {
          deferViewUpdate(this.cdr, () => {
            this.initLoading = false;
          });
        }),
      )
      .subscribe({
        next: (data) => {
          deferViewUpdate(this.cdr, () => {
            this.operationInfo = data;
            this.bankList = data.bankList.map((bank) => ({
              label: bank.name,
              value: bank.code,
            }));
          });
        },
        error: (error) => {
          console.error('Error en la solicitud:', error);
          deferViewUpdate(this.cdr, () => {
            this.router.navigate(['/error-status/movii']);
          });
        },
      });
  }

  downloadPdf(event: MouseEvent): void {
    event.stopPropagation();
    const link = document.createElement('a');
    link.href = 'assets/pdf/pse/politica.pdf';
    link.download = 'Política de Privacidad de Datos.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  handleCheckboxClick(event: MouseEvent): void {
    event.stopPropagation();
  }

  createOperation() {
    this.loading = true;
    const formValue = this.formPseComponent.form.getRawValue();
    const body: MoviiCreateOperationRequest = {
      sessionId: this.verification,
      bank: {
        code: String(formValue.bank ?? ''),
        name: String(formValue.bankName ?? ''),
      },
      customer: {
        name: String(formValue.name ?? ''),
        typePerson: String(formValue.type ?? ''),
        documentType: String(formValue.documentType ?? ''),
        documentNumber: String(formValue.documentNumber ?? ''),
        email: String(formValue.mail ?? ''),
      }
    }


    this.moviiService.createOperation(body).subscribe({
      next: (data) => {

        if (data.operation.status == '6') {
          window.location.href = data.operation.errorUrl;
        } else {
          window.location.href = data.operation.bankUrl;
        }
        this.loading = false;
      },
      error: (error) => {
        this.snackBar.open('Error al crear la operación', '', {
          duration: 2000,
        });
        this.loading = false;
      },
      complete: () => {
        this.loading = false;
      }
    });



  }
}
